import axios from "axios";
import React, { useEffect, useContext, useState } from "react";
import UserDataContext from "../../context/UserDataContext";

function Changelog() {
  const [recordData, setRecordData] = useState({});
  const [error, setError] = useState(false);
  const token = localStorage.getItem("token");
  const project = localStorage.getItem("currentProjectID");
  const [success, setSuccess] = useState(false);
  const { userData } = useContext(UserDataContext);

  return (
    <>
      <div className="bg-white shadow overflow-hidden sm:rounded-lg flex justify-center my-5">
        <div className="px-4 py-5 sm:px-6 justify-start lg:w-0 lg:flex-1">
          <div>
            <div className="px-4 sm:px-0">
              <h3 className="text-base font-semibold leading-7 text-gray-900">
                Changelog
              </h3>
              <p className="mt-1 max-w-2xl text-sm leading-6 text-gray-500">
                Übersicht über die Neuerungen der letzten Releases.
              </p>
            </div>
            <div className="mt-6 border-t border-gray-100">
              <dl className="divide-y divide-gray-100">
                <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                  <dt className="text-sm font-medium leading-6 text-gray-900">
                    Version 1.0
                  </dt>
                  <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                    Initialer Release. TBD
                  </dd>
                </div>
              </dl>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Changelog;
